import React, { useState, useEffect, useMemo } from 'react';
import { Autocomplete, TextField, Table, TableBody, TableSortLabel, TableCell, TableContainer, TableHead, CircularProgress, TableRow, Paper, Button, TablePagination, Checkbox, Grid, Modal, Box, Typography, Alert } from '@mui/material';
import GestionCotizaciones from './GestionCotizacion'; // Asegúrate de que la ruta sea correcta
import GestionOrdenTrabajo from './GestionOrdenTrabajo';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useSucursal } from '../contexts/SucursalContext';
import { useAccesos } from '../contexts/AccesosContext';
import OrdenesTrabajo from './OrdenesTrabajo';
function Cotizaciones() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { sucursalSeleccionada, setSucursalSeleccionada } = useSucursal();
    const [cotizaciones, setCotizaciones] = useState([]);
    const [totalCotizaciones, setTotalCotizaciones] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sucursales, setSucursales] = useState([]);
    // const [isLoadingMore, setIsLoadingMore] = useState(false);
    // const [hasMore, setHasMore] = useState(true);
    const [selectedCotizacion, setSelectedCotizacion] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [cotizacionData, setCotizacionData] = useState(null); // Datos de la cotización a modificar
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [openOrdenTrabajoModal, setOpenOrdenTrabajoModal] = useState(false);    const [ordenTrabajoData, setOrdenTrabajoData] = useState(null);
    const { user } = useUser();
    const [fechaInicio, setFechaInicio] = useState(''); // formato 'YYYY-MM-DD'
    const [fechaFin, setFechaFin] = useState(''); // formato 'YYYY-MM-DD'
    
    // Estados para vista previa del PDF
    const [openPrintPreview, setOpenPrintPreview] = useState(false);
    const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [previewError, setPreviewError] = useState(null);

    // const paginatedCotizaciones = useMemo(() => {
    //     const start = page * rowsPerPage;
    //     const end = start + rowsPerPage;
    //     return cotizaciones.slice(start, end);
    // }, [cotizaciones, page, rowsPerPage]);

    // Estados para el ordenamiento
        const [orderBy, setOrderBy] = useState('');
        const [order, setOrder] = useState('asc');

    // Función para manejar el ordenamiento
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // Función para comparar valores en el ordenamiento
    const descendingComparator = (a, b, orderBy) => {
        let valueA = a[orderBy];
        let valueB = b[orderBy];

        // Manejar fechas
        if (orderBy.includes('fecha') || orderBy.includes('Fecha')) {
            valueA = new Date(valueA);
            valueB = new Date(valueB);
        }
        // Manejar números
        else if (typeof valueA === 'string' && !isNaN(valueA)) {
            valueA = parseFloat(valueA) || 0;
            valueB = parseFloat(valueB) || 0;
        }
        // Manejar strings (case insensitive)
        else if (typeof valueA === 'string' && typeof valueB === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
        }

        if (valueB < valueA) {
            return -1;
        }
        if (valueB > valueA) {
            return 1;
        }
        return 0;
    };

        const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };


    // Función para cargar sucursales (Autocomplete)
    const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            // Se asume data.$values o data es la lista de sucursales
            const lista = data.$values || data;
            setSucursales(lista);

            // Ejemplo: si ya tienes la sucursal por defecto, podrías setearla acá
            // p. ej. si user tiene user.sucursalSeleccionada
            // const sucursalDefecto = lista.find((s) => s.idSucursal === user.sucursalSeleccionada);
            // setSucursalSeleccionada(sucursalDefecto);

        } catch (error) {
            console.error('Error al obtener sucursales:', error);
        }
    };

    const handleSucursalSeleccionada = (event, newValue) => {
        if (newValue) {
            // supongamos que newValue === { idSucursal, nombreSucursal, ... }
            setSucursalSeleccionada(newValue);
        } else {
            setSucursalSeleccionada(0);
        }
    };

    // Función para cargar cotizaciones desde la API con paginación y búsqueda
    // Cargar cotizaciones con posibilidad de pasarle fechas
    const fetchCotizaciones = async (
        search = '',
        fi = fechaInicio, // Por defecto, las del estado
        ff = fechaFin,
        pageNum = 1,
        append = false
        
    ) => {
        try {
            if (pageNum === 1) {
                setLoading(true);
            } else {
                setLoadingMore(true);
            }
            
            const prevLength = append ? cotizaciones.length : 0;

             const bodyData = {
                page: pageNum,
                limit: rowsPerPage,
                search,
                idSucursal: sucursalSeleccionada ? sucursalSeleccionada.idSucursal : 0,
                fechaInicio: fi,
                fechaFin: ff,
                
            };
            console.log("COTIZACIONES: ", bodyData);
            const response = await fetch(`${server}/Cotizaciones/Paginadosbysucursal`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData),
            });

            const data = await response.json();
            const listadoCotizaciones = data.cotizaciones?.$values || data.cotizaciones || [];
            const totalFromBackend = data.total || data.Total || 0;

            const newTotalLoaded = prevLength + listadoCotizaciones.length;

            if (append) {
                setCotizaciones(prev => [... prev, ...listadoCotizaciones]);
            } else {
                setCotizaciones(listadoCotizaciones)
            }

            setTotalCotizaciones(totalFromBackend);
            setCurrentPage(pageNum);
            setHasMore(newTotalLoaded < totalFromBackend);

            // setCotizaciones(data.cotizaciones.$values || data.cotizaciones || []);
            // setTotalCotizaciones(data.total || 0);
        } catch (error) {
            console.error('Error al cargar las cotizaciones:', error);
            if (!append){
                setCotizaciones([]);
                setTotalCotizaciones(0);
            }
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const paginatedCotizaciones = useMemo(() => {
            const sortedData = orderBy
                ? [...cotizaciones].sort(getComparator(order, orderBy))
                : cotizaciones;
            
            const start = page * rowsPerPage;
            const end = start + rowsPerPage;
            return sortedData.slice(start, end);
        }, [cotizaciones, order, orderBy, page, rowsPerPage]);


    const calcularFechaPlazo = (fechaCotizacion, idTipoDuracion, duracion) => {
        let fecha = dayjs(fechaCotizacion);
        switch (idTipoDuracion) {
            case 2:
                fecha = fecha.add(duracion, 'day');
                break;
            case 3:
                fecha = fecha.add(duracion, 'week');
                break;
            case 4:
                fecha = fecha.add(duracion, 'month');
                break;
            case 5:
                fecha = fecha.add(duracion, 'year');
                break;
            default:
                break;
        }
        return fecha.format('YYYY-MM-DD');
    };



    // Al montar, asignamos las fechas por defecto y cargamos datos
    useEffect(() => {
        const now = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);

        // Convertir a YYYY-MM-DD
        const defaultInicio = startDate.toISOString().split('T')[0];
        const defaultFin = now.toISOString().split('T')[0];

        // Cargar sucursales
        fetchSucursales();

        // Llamamos a la API con esas fechas "por defecto" (así carga en la primera vez)
        // OJO: No tenemos todavía en el estado, pero se las pasamos directo a la función.
        fetchCotizaciones(searchQuery, defaultInicio, defaultFin);

        // Guardamos esas fechas en el estado
        setFechaInicio(defaultInicio);
        setFechaFin(defaultFin);
    }, []);
    // Cargar más cotizaciones al cambiar de página
    // useEffect(() => {
    //     if (page * rowsPerPage >= cotizaciones.length - rowsPerPage && hasMore && !isLoadingMore) {
    //         setIsLoadingMore(true);
    //         fetchCotizaciones(page, 100, searchQuery).then(() => setIsLoadingMore(false));
    //     }
    // }, [page]);


    // Manejo de fecha
    const handleFechaInicioChange = (e) => {
        setFechaInicio(e.target.value);
    };
    const handleFechaFinChange = (e) => {
        setFechaFin(e.target.value);
    };



    // Manejar cambio en el campo de búsqueda
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Manejar búsqueda al hacer clic en el botón
  // Cuando presiono "Buscar", sí llamo fetchCotizaciones con las fechas del estado
  const handleSearch = () => {
    setPage(0);
    setCurrentPage(1);
    fetchCotizaciones(searchQuery, fechaInicio, fechaFin, 1, false);
  };

    // Manejar cambio de página
    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        // Si estamos llegando al final de los datos cargados y hay mas datos disponibles
        const isNearEnd = (newPage + 1) * rowsPerPage >= cotizaciones.length;
        if (isNearEnd && hasMore && !loadingMore) {
            fetchCotizaciones(searchQuery, fechaInicio, fechaFin, currentPage + 1, true);
        }
    };

    // Manejar cambio en el número de filas por página
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        setCurrentPage(1);
        fetchCotizaciones(searchQuery, fechaInicio, fechaFin, 1, false);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    // Manejar selección de una cotización
    const handleSelectCotizacion = (cotizacion) => {
        setSelectedCotizacion(cotizacion);
    };

    // Función para formatear el número de WhatsApp
    const formatWhatsappNumber = (telefono) => {
        if (!telefono) return '';
        // Elimina espacios, guiones y paréntesis
        let cleaned = telefono.replace(/[\s\-()]/g, '');
        // Si ya empieza con +504, lo deja igual
        if (cleaned.startsWith('+504')) return cleaned;
        // Si empieza con 504 sin +, lo agrega
        if (cleaned.startsWith('504')) return '+' + cleaned;
        // Si solo es el número, lo agrega
        if (cleaned.length === 8) return '+504' + cleaned;
        // Si ya tiene + y otro país, lo deja igual
        if (cleaned.startsWith('+')) return cleaned;
        // Por defecto, retorna como está
        return cleaned;
    };

    const handleWhatsapp = async () => {
        if (!selectedCotizacion) {
            Swal.fire({
                text: 'Por favor selecciona una cotización.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Obtener los datos completos de la cotización para obtener idCliente
            const responseCotizacion = await fetch(`${server}/Cotizaciones/${selectedCotizacion.idCotizacion}`);
            if (!responseCotizacion.ok) {
                throw new Error('No se pudo obtener la información de la cotización');
            }
            const cotizacionCompleta = await responseCotizacion.json();
            
            // Obtener los datos del cliente
            const responseCliente = await fetch(`${server}/MgClientes/GetByIdCliente/${cotizacionCompleta.idCliente}`);
            if (!responseCliente.ok) {
                throw new Error('No se pudo obtener la información del cliente');
            }
            const cliente = await responseCliente.json();
            
            console.log('Datos del cliente:', cliente);
            console.log('Teléfono:', cliente?.telefono);
            console.log('Celular:', cliente?.celular);

            // Si estamos en vista previa, cerramos el modal primero
            if (openPrintPreview) {
                handleClosePrintPreview();
            }
            
            // Usar celular si está disponible, sino telefono
            const numeroTelefono = cliente?.celular || cliente?.telefono || '';
            
            const { value: numeroWhatsapp } = await Swal.fire({
                title: 'Ingrese el número de WhatsApp',
                input: 'text',
                inputLabel: 'Número de WhatsApp',
                inputPlaceholder: '+50433333333',
                inputValue: formatWhatsappNumber(numeroTelefono),
                showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            focusConfirm: false,
            focusInput: true,
            inputAutoFocus: true,
            inputAutoTrim: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Por favor ingrese un número de WhatsApp';
                }
                // Validar que el número de WhatsApp tenga un formato adecuado
                const whatsappRegex = /^\+?[0-9]{1,4}[0-9]{10,15}$/;
                if (!whatsappRegex.test(value)) {
                    return 'Por favor ingrese un número de WhatsApp válido, incluyendo el código de área si es necesario';
                }
            }
        });
            if (numeroWhatsapp) {
                try {
                    const response = await fetch(`${server}/Whatsapp/PostCotizaciontoWhatsapp?idCotizacion=${selectedCotizacion.idCotizacion}&numeroWhatsapp=${numeroWhatsapp}`, {
                        method: 'POST',
                    });

                    if (response.ok) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Whatsapp Enviado',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    } else {

                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error Enviar Whatsapp',
                        text: error || 'Ocurrió un error inesperado',
                    });
                }
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al obtener los datos',
            });
        }
    };
    // Acciones con la cotización seleccionada    // Función para cerrar el modal de vista previa
    const handleClosePrintPreview = () => {
        if (previewPdfUrl) {
            window.URL.revokeObjectURL(previewPdfUrl);
            setPreviewPdfUrl(null);
        }
        setOpenPrintPreview(false);
        setPreviewError(null);
    };

    // Función para manejar la vista previa del PDF
    const handleImprimirPreview = async () => {
        if (!selectedCotizacion) {
            Swal.fire({ text: 'Por favor selecciona una cotización.', icon: 'warning' });
            return;
        }
        setPreviewLoading(true);
        setPreviewError(null);
        setOpenPrintPreview(true);
        try {
            const response = await fetch(`${server}/Cotizaciones/ImprimirCotizacion/${selectedCotizacion.idCotizacion}`, {
                method: 'POST',
            });
            if (!response.ok) {
                throw new Error(`Error al generar el PDF: ${response.status} ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setPreviewPdfUrl(url);
        } catch (err) {
            setPreviewError(err.message || 'Error al generar la vista previa del PDF');
        } finally {
            setPreviewLoading(false);
        }
    };

    // Asignar la función de vista previa al botón de imprimir
    const handleImprimir = handleImprimirPreview;

    const handleModificar = async () => {
        console.log(selectedCotizacion);
        if (selectedCotizacion) {
            try {
                // Paso 1: Obtener la cotización seleccionada
                const responseCotizacion = await fetch(`${server}/Cotizaciones/${selectedCotizacion.idCotizacion}`);
                const cotizacion = await responseCotizacion.json();

                console.log(cotizacion);

                // Paso 2: Obtener los detalles de la cotización (analisisAgregados)
                // const responseDetalles = await fetch(`${server}/CtzCotizacionesDetalles/porIdCotizacion/${selectedCotizacion.idCotizacion}`);
                // const detalles = await responseDetalles.json();

                // console.log(detalles.$values);
                // Paso 3: Preparar los datos para pasar al componente GestionCotizaciones
                setCotizacionData({
                    cotizacion: cotizacion,
                    detalles: [], // Asegurarse de que sea un array
                    modo: 'modificar',
                });

                // Paso 4: Abrir el modal
                setOpenModal(true);

            } catch (error) {
                console.error('Error al obtener la cotización:', error);
                alert('Hubo un error al obtener la cotización.');
            }
        } else {
            alert('Por favor selecciona una cotización.');
        }
    };

    const handleAnular = () => {
        if (selectedCotizacion) {
            console.log('Anular cotización:', selectedCotizacion);
            // Lógica para anular la cotización
        } else {
            alert('Por favor selecciona una cotización.');
        }
    };

    const handleCorreo = async () => {
        if (!selectedCotizacion) {
            Swal.fire({
                text: 'Por favor selecciona una cotización.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Obtener los datos completos de la cotización para obtener idCliente
            const responseCotizacion = await fetch(`${server}/Cotizaciones/${selectedCotizacion.idCotizacion}`);
            if (!responseCotizacion.ok) {
                throw new Error('No se pudo obtener la información de la cotización');
            }
            const cotizacionCompleta = await responseCotizacion.json();
            
            // Obtener los datos del cliente
            const responseCliente = await fetch(`${server}/MgClientes/GetByIdCliente/${cotizacionCompleta.idCliente}`);
            if (!responseCliente.ok) {
                throw new Error('No se pudo obtener la información del cliente');
            }
            const cliente = await responseCliente.json();
            
            console.log('Datos del cliente:', cliente);
            console.log('Correo:', cliente?.correoElectronico);

            // Si estamos en vista previa, cerramos el modal primero
            if (openPrintPreview) {
                handleClosePrintPreview();
            }

            const { value: email } = await Swal.fire({
                title: 'Enviar por correo electrónico',
                input: 'email',
                inputLabel: 'Dirección de correo electrónico',
                inputPlaceholder: 'Ingrese el correo electrónico',
                inputValue: cliente?.correoElectronico || '',
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                focusConfirm: false,
                focusInput: true,
                inputAutoFocus: true,
                inputAutoTrim: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Por favor ingrese una dirección de correo válida';
                    }
                    // Validación básica de email
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) {
                        return 'Por favor ingrese un correo electrónico válido';
                    }
                }
            });

            if (email) {
                try {
                    const response = await fetch(`${server}/Correo/enviar-cotizacion?idCotizacion=${selectedCotizacion.idCotizacion}&destinatario=${encodeURIComponent(email)}&asunto=Cotizaci%C3%B3n%20Laboratorio`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });

                    if (response.ok) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Correo Enviado',
                            text: 'La cotización ha sido enviada por correo electrónico',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    } else {
                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al enviar correo',
                        text: error.message || 'Ocurrió un error inesperado',
                    });
                }
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al obtener los datos',
            });
        }
    };


    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '85%',
        height: '90vh',
        backgroundColor: '#fff',
        padding: '20px',
        boxShadow: 24,
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
    };


    const handleCrearOrden = async () => {
        // Si estamos en vista previa, cerramos el modal primero
        if (openPrintPreview) {
            handleClosePrintPreview();
        }
        
        if (selectedCotizacion) {
            // Mostrar confirmación al usuario
            const result = await Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea crear una Orden de Trabajo a partir de la cotización seleccionada?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, crear',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: false
            });

            if (result.isConfirmed) {
                try {
                    // Paso 1: Obtener la cotización completa
                    const responseCotizacion = await fetch(`${server}/Cotizaciones/${selectedCotizacion.idCotizacion}`);
                    if (!responseCotizacion.ok) {
                    throw new Error('No se pudo obtener la información de la cotización');
                    }
                    const cotizacion = await responseCotizacion.json();

                    console.log(cotizacion);
                    // Paso 2: Obtener los detalles de la cotización
                    const responseDetalles = await fetch(`${server}/CtzCotizacionesDetalles/porIdCotizacion/${selectedCotizacion.idCotizacion}`);
                    if (!responseDetalles.ok) {
                    throw new Error('No se pudieron obtener los detalles de la cotización');
                    }
                    const detallesCotizacion = await responseDetalles.json();
                    console.log(detallesCotizacion);

                    //Validar examenes repetidos
                    const detalles = detallesCotizacion.$values;

                    const examenesRepetidos = detalles.reduce((acc, item) => {
                        const id = item.idTipoAnalisis;

                        if (!acc[id]) {
                            acc[id] = {
                                cantidad: 0,
                                descripcion: item.descripcionTipoAnalisis 
                            };
                        }

                        acc[id].cantidad += item.cantidad || 1;

                        return acc;
                    }, {});

                    const repetidos = Object.values(examenesRepetidos)
                        .filter(x => x.cantidad > 1);
    
                    if (repetidos.length > 0 ){
                         Swal.fire({
                            icon: 'warning',
                            title: 'No se puede crear la Orden de Trabajo',
                            html: `
                                La cotización contiene exámenes repetidos:<br/><br/>
                                <b>${repetidos.map(x => `${x.descripcion} (${x.cantidad})`).join('<br/>')}</b>
                            `,
                            confirmButtonColor: "primary"
                        });
    
                        return;
                    }

                    // Obtener el correlativo
                    const responseCant = await fetch(`${server}/MgOrdenesMedicas/cantidad`);
                    const data = await responseCant.json();
                    const correlativoActual = parseInt(data.toString().slice(4)); // Eliminar los primeros 4 dígitos
                    const nuevoCorrelativo = correlativoActual + 1;



                    // Obtener el año y el mes actuales
                    const fechaActual = new Date();
                    const year = fechaActual.getFullYear().toString().slice(-2); // Últimos 2 dígitos del año
                    const month = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Mes con dos dígitos

                    // Construir idOrdenMedicaMes
                    const idOrdenMedicaMes = `${year}${month}${nuevoCorrelativo}`;


                    const now = new Date();

                    // Para fechaCotizacion (solo fecha)
                    const currentYear = now.getFullYear();
                    const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 (enero) a 11 (diciembre)
                    const currentDay = String(now.getDate()).padStart(2, '0');

                    const fechaActual1 = `${currentYear}-${currentMonth}-${currentDay}`; // Formato YYYY-MM-DD

                    // Para fechaRecepcion y fechaEntrega (fecha y hora)
                    const currentHours = String(now.getHours()).padStart(2, '0');
                    const currentMinutes = String(now.getMinutes()).padStart(2, '0');

                    const fechaHoraActual = `${fechaActual1}T${currentHours}:${currentMinutes}`; // Formato YYYY-MM-DDTHH:MM


                    // Paso 3: Crear la Orden de Trabajo (encabezado)
                    const nuevaOrden = {
                        // Mapea los campos necesarios desde la cotización a la orden de trabajo
                      //  idOrdenMedica: 0,
                        idOrdenMedicaMes: idOrdenMedicaMes,
                        idCliente: cotizacion.idCliente,
                        correo: cotizacion.correo ? cotizacion.correo : '',
                        idBarrioColonia: 0,
                        fechaOrdenMedica: fechaActual1,
                        duracion: cotizacion.duracion,
                        idTipoDuracion: cotizacion.idTipoDuracion,
                        idTipoPago: cotizacion.idTipoPago,
                        valorVenta: cotizacion.valorVenta,
                        valorDescuento: cotizacion.valorDescuento,
                        valorRecargo: cotizacion.valorRecargo ? cotizacion.valorRecargo : 0,
                        telefono: cotizacion.telefono ? cotizacion.telefono : "",
                        celular: cotizacion.celular ? cotizacion.celular : '',
                        idSucursal: cotizacion.idSucursal,
                        idMedico: cotizacion.idMedico ? cotizacion.idMedico : 0,
                        idOrigen: cotizacion.idOrigen ? cotizacion.idOrigen : 0,
                        idMedioPago: 0,
                        enviarXWhatsapp: cotizacion.enviarWhatsapp ? true : false,
                        enviarXCorreo: false,
                        enviarXApp: false,
                        imprimir: false,
                        porcetajeCopago: 0,
                        idPoliza: 0,
                        polizaValorMinimo: 0,
                        polizaValorMaximo: 0,
                        polizaPrevalidado: false,
                        idSucursalEntrega: cotizacion.idSucursal,
                        polizaNumeroTransaccion: '',
                        polizaNumeroVericacion: '',
                        polizaDeduccible: 0,
                        polizaElegible: 0,
                        idPoliza: 0,
                        idTipo: 1,
                        idTipoCliente: 1,
                        ingresadoPor: user ? user.codigoUsuario : 'ADMIN',
                        fechaRecepcion: fechaHoraActual,
                        fechaEntrega: fechaHoraActual,
                        idOrdenParaControl: 0,
                        observaciones: '',
                        idCanalDeVentas: cotizacion.idCanalDeVentas


                        // Agrega otros campos necesarios...
                    };
                   
                    // const ordenCreada = await responseCrearOrden.json();

                    // Paso 4: Crear los detalles de la Orden de Trabajo
                    const detallesOrden = detallesCotizacion.$values.map(detalle => {
                        const precio = parseFloat(detalle.valorVenta) || 0;
                        const descuento = parseFloat(detalle.valorDescuento) || 0;
                        const total = (precio - descuento).toFixed(2);

                        return {
                       // idDetalle: 0,
                        // idOrdenMedica: idOrdenMedica,
                        // modificacion: 1,
                        idModulo: detalle.idModulo,
                        idTipoAnalisis: detalle.idTipoAnalisis,
                        comentarios: '',
                        analisis: detalle.descripcionTipoAnalisis || String(detalle.idTipoAnalisis),
                        fechaOrdenMedica: fechaActual1,
                        cantidad: detalle.cantidad,
                        idTipoPrecio: detalle.idTipoPrecio ? detalle.idTipoPrecio : 3,
                        // valorVenta: detalle.valorVenta,
                        precio: precio,
                        // valorDescuento: detalle.valorDescuento,
                        descuento: descuento.toFixed(2),
                        total: total,
                        PolizaElegible: detalle.polizaElegible || false,
                        // ingresadoPor: user ? user.codigoUsuario : 'ADMIN',
                        idPromocion: detalle.idPromocion,
                        descuentoDelBackend: true,
                        };
                        // Agrega otros campos necesarios...
                    });


                    setOrdenTrabajoData({
                        ordenTrabajo: {
                         ...nuevaOrden,
                         idCotizacion: selectedCotizacion.idCotizacion
                        },
                        detalles: detallesOrden
                    });

                    setOpenOrdenTrabajoModal(true);

                } catch (error) {
                    console.error('Error al crear la Orden de Trabajo:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.message || 'Ocurrió un error al crear la Orden de Trabajo.',
                    });
                }
            }
        } else {
            Swal.fire('Por favor selecciona una cotización.');
        }
    };


    return (
        <>
        <div className="right_col" role="main">
            
            <div className="x_content">
                <h2>Listado de Cotizaciones</h2>
                <br />
                {/* <div className="row"> */}
                    {/* <div className="col-md-9 col-sm-4 offset-md-2"> */}
                        <Grid container spacing={1} alignItems="center" style={{ marginBottom: '20px' }}>
                            {/* Autocomplete de Sucursales */}
                            <Grid item xs={12} md={2}>
                                <Autocomplete
                                size="small"
                                    options={sucursales}
                                    getOptionLabel={(option) => option.nombreSucursal || ''}
                                    value={sucursalSeleccionada}
                                    onChange={handleSucursalSeleccionada}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Sucursal"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Fechas */}
                            <Grid item xs={12} md={2}>
                                <TextField
                                size="small"
                                    label="Fecha Inicio"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fechaInicio}
                                    onChange={handleFechaInicioChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                size="small"
                                    label="Fecha Fin"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fechaFin}
                                    onChange={handleFechaFinChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField
                                size="small"
                                    variant="outlined"
                                    label="Buscar cotización por Nombre/ Identidad/ Celular"
                                    fullWidth
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    onKeyDown={handleKeyDown}
                                />
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Button size="small" variant="contained" color="primary" onClick={handleSearch}>
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Button size="small" variant="contained" color="primary" onClick={handleImprimir} disabled={!tienePermiso('Imprimir Cotización Listado')}>
                                    Imprimir
                                </Button>
                                <Button size="small" variant="contained" color="primary" onClick={handleWhatsapp} style={{ marginLeft: '10px' }} disabled={!tienePermiso('Enviar WhatsApp Cotización')}>
                                    WhatsApp
                                </Button>
                                <Button size="small" variant="contained" color="primary" onClick={handleCorreo} style={{ marginLeft: '10px' }} disabled={!tienePermiso('Enviar Correo Cotización')}>
                                    Correo
                                </Button>
                                <Button size="small" variant="contained" color="secondary" onClick={handleModificar} style={{ marginLeft: '10px' }} disabled={!tienePermiso('Editar Cotización Listado')}>
                                    Modificar
                                </Button>
                                <Button size="small" variant="contained" color="secondary" onClick={handleAnular} style={{ marginLeft: '10px' }} disabled={!tienePermiso('Eliminar Cotización Listado')}>
                                    Anular
                                </Button>
                                <Button size="small" variant="contained" onClick={handleCrearOrden} style={{ marginLeft: '10px', backgroundColor: 'green', color: 'white' }} disabled={!tienePermiso('Generar Orden de Trabajo')}>
                                    Crear Orden de Trabajo
                                </Button>
                            </Grid>
                        </Grid>
                        {loading ? (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                                <Table size="small" stickyHeader aria-label="detalles">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Seleccionar</TableCell>
                                            <TableCell style={{ fontWeight: 'bold'}}>
                                                <TableSortLabel
                                                    active={orderBy === 'fechaCotizacion'}
                                                    direction={orderBy === 'fechaCotizacion' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('fechaCotizacion')}
                                                >                                        
                                                Fecha
                                                </TableSortLabel>    
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'idCotizacion'}
                                                    direction={orderBy === 'idCotizacion' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('idCotizacion')}
                                                >
                                                N° Cotizacion
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'nombreCompleto'}
                                                    direction={orderBy === 'nombreCompleto' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('nombreCompleto')}
                                                >
                                                Nombre Cliente
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'nombreMedico'}
                                                    direction={orderBy === 'nombreMedico' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('nombreMedico')}
                                                >
                                                Nombre Medico
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'valorVenta'}
                                                    direction={orderBy === 'valorVenta' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('valorVenta')}
                                                >
                                                Total
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Fecha Plazo</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Tipo</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                <TableSortLabel
                                                    active={orderBy === 'ingresadoPor'}
                                                    direction={orderBy === 'ingresadoPor' ? order : 'asc'}
                                                    onClick={() => handleRequestSort('ingresadoPor')}
                                                >
                                                Creada por
                                                </TableSortLabel>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedCotizaciones.map((cotizacion) => (
                                            <TableRow key={cotizacion.idCotizacion}>
                                                <TableCell style={{ padding: '4px' }}>
                                                    <Checkbox
                                                        checked={selectedCotizacion?.idCotizacion === cotizacion.idCotizacion}
                                                        onChange={() => handleSelectCotizacion(cotizacion)}
                                                    />
                                                </TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.fechaCotizacion}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.idCotizacion}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.nombreCompleto}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.nombreMedico}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.valorVenta}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>
                                                    {calcularFechaPlazo(cotizacion.fechaCotizacion, cotizacion.idTipoDuracion, cotizacion.duracion)}
                                                </TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.tipo}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{cotizacion.ingresadoPor}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 100, 200]}
                                    component="div"
                                    count={totalCotizaciones}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                />
                            </TableContainer>
                        )}
                        <Modal
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                        >
                            <div style={modalStyle}>
                                {cotizacionData && (
                                    <GestionCotizaciones
                                        cotizacion={cotizacionData.cotizacion}
                                        detalles={cotizacionData.detalles}
                                        modo={cotizacionData.modo}
                                        onClose={() => {
                                            setOpenModal(false);
                                            // Opcional: Recargar la lista de cotizaciones si se han hecho nuevos cambios
                                            fetchCotizaciones(searchQuery);

                                            
                                        }}
                                    />
                                )}
                            </div>
                        </Modal>
                        <Modal
                            open={openOrdenTrabajoModal}
                            onClose={() => setOpenOrdenTrabajoModal(false)}
                            aria-labelledby="modal-title-orden-trabajo"
                            aria-describedby="modal-description-orden-trabajo"
                            disableEscapeKeyDown={false}
                            disableBackdropClick={false}
                        >
                            <div style={modalStyle}>
                                {ordenTrabajoData && ordenTrabajoData.detalles?.length > 0 && (
                                    <GestionOrdenTrabajo
                                        ordenTrabajo={ordenTrabajoData.ordenTrabajo}
                                        detalles={ordenTrabajoData.detalles}
                                        onClose={() => {
                                            setOpenOrdenTrabajoModal(false);
                                            // Opcional: Recargar la lista de cotizaciones o de órdenes de trabajo si es necesario
                                            // Cerrar el modal de cotización si sigue abierto
                                        if (typeof onClose === 'function') {
                                            onClose();
                                        }
                                        }}
                                    />
                                )}                            </div>
                        </Modal>

                        {/* Modal de Vista Previa del PDF */}
                        <Modal
                            open={openPrintPreview}
                            onClose={handleClosePrintPreview}
                            aria-labelledby="modal-title-print-preview"
                            aria-describedby="modal-description-print-preview"
                        >
                            <div style={modalStyle}>
                                <h2>Vista Previa de Impresión</h2>
                                {previewLoading && (
                                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="400px">
                                        <CircularProgress size={60} />
                                        <Typography variant="body1" style={{ marginTop: 16 }}>
                                            Generando vista previa del PDF...
                                        </Typography>
                                    </Box>
                                )}
                                {previewError && (
                                    <Box p={3}>
                                        <Alert severity="error">{previewError}</Alert>
                                    </Box>
                                )}
                                {previewPdfUrl && !previewLoading && !previewError && (
                                    <>
                                        <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', height: 'calc(90vh - 150px)' }}>
                                            <iframe
                                                src={previewPdfUrl}
                                                style={{ width: '100%', height: '100%', border: 'none', flexGrow: 1 }}
                                                title="Vista previa del PDF"
                                            />
                                        </Box>
                                        <Box mt={2} display="flex" justifyContent="center" gap={2}>
                                            <Button size="small" variant="contained" color="primary" onClick={handleWhatsapp}>
                                                WhatsApp
                                            </Button>
                                            <Button 
                                                size="small" 
                                                variant="contained" 
                                                onClick={handleCrearOrden} 
                                                style={{ backgroundColor: 'green', color: 'white' }}
                                            >
                                                Crear Orden de Trabajo
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </div>
                        </Modal>

                    {/* </div> */}
                {/* </div> */}
            </div>
            </div>
        </>
    );
}

export default Cotizaciones;
